import {
    TSeriesActions,
    LOAD_SERIES,
    LOAD_SERIES_SUCCESS,
    LOAD_SERIES_FAILURE,
    SET_SELECTED_SERIES,
} from '../actions/Series';
import { TMeta, TSeries } from '../types';

type TState = {
    fetching: boolean;
    error: unknown;
    content: TSeries[];
    meta: TMeta,
    selectedSeries: TSeries;
};

const initialState: TState = {
    fetching: false,
    error: undefined,
    content: [],
    meta: {
        count: 0,
        previous: null,
        next: null,
        status_code: undefined,
    },
    selectedSeries: null,
};

const reducer = (state = initialState, action: TSeriesActions): TState => {
    switch (action.type) {
        case LOAD_SERIES:
            return {
                ...state,
                error: undefined,
                fetching: true,
            };
        case LOAD_SERIES_SUCCESS:
            return {
                ...state,
                content: action.payload.content,
                meta: action.payload.meta,
                fetching: false,
            };
        case LOAD_SERIES_FAILURE:
            return {
                ...state,
                error: action.payload.content,
                meta: action.payload.meta,
                fetching: false,
            };
        case SET_SELECTED_SERIES:
            return {
                ...state,
                selectedSeries: action.selectedSeries,
            };
        default:
            return state;
    }
};

export default reducer;
